import type { ProductOrderBuddy } from '~/types/orderbuddy-types'
import { useModal } from 'vue-final-modal'
import ModalProduct from '~/components/Modal/ModalProduct/ModalProduct.vue'
import { blockScroll, unBlockScroll } from '~/composables/blockScroll'

export async function showExtrasModal (product: ProductOrderBuddy, productKeyToReplace?: string) {
    const extrasModalInstance = useModal({
        component: ModalProduct,
        attrs: {
            ...product,
            productKeyToReplace,
            onBeforeOpen () {
                blockScroll(window.scrollY)
            },
            onBeforeClose () {
                unBlockScroll()
            },
            async onClose () {
                await extrasModalInstance.close()
            }
        }
    })
    await extrasModalInstance.open()
}
